import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { Form, InputNumber, Select, Table } from 'tdesign-react';
import { peekMessages } from '@/services/topicService';
import useTable from '@/hooks/useTable';
import { getSubscriptions } from '@/services/utilService';
import { toTsOptions } from '@/utils/common';
import { columns } from '..';

const { FormItem } = Form;

export default function PeekMessages({ commonProps }) {
  const [options, setOptions] = useState([]);

  const loadOptions = useMemoizedFn(async () => {
    const { data } = await getSubscriptions({
      ...commonProps,
      subscription: '',
    });
    setOptions(
      (data || []).map((item) => ({
        label: item.subscription,
        value: item.subscription,
      })),
    );
  });

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await peekMessages({
      ...commonProps,
      ...params,
    });
    setData(data);
  });

  const { header, config, setData } = useTable({
    columnController: null,
    onSearch: loadData,
    refresh: null,
    columns,
    search: (
      <>
        <FormItem name='subscription' rules={[{ required: true }]}>
          <Select
            options={toTsOptions(options)}
            popupProps={{ overlayInnerStyle: { width: 'auto' } }}
            filterable
            clearable
            placeholder='请选择订阅名'
          />
        </FormItem>
        <FormItem name='messageNum' rules={[{ required: true }]}>
          <InputNumber
            theme='normal'
            placeholder='请输入消息数量'
            decimalPlaces={0}
            style={{ width: 'auto', flex: 1 }}
          />
        </FormItem>
      </>
    ),
  });

  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  return (
    <>
      {header}
      <Table {...config} />
    </>
  );
}
